import PrimaryGroupOverride from './PrimaryGroupOverride'
import Employee from './Employee'
export class SavePrimaryGroupOverrideRequest {
    PrimaryGroupOverride: PrimaryGroupOverride;
    SavedByEmployee: Employee;
}

export default SavePrimaryGroupOverrideRequest;